module.exports = "pegasus/assets/themelp1/small/27.png";